import LogoImg from 'url:img/esd.png';

const LogoComponent = ({ className }: { className?: string }) => (
  <img className={className} src={LogoImg} alt="esd.next" />
);

export default LogoComponent;
